import React, { useState, useEffect } from 'react';
import './styles/floatingcart.css';
import { ChevronRight } from 'lucide-react';
import { useCart } from '../../../../contexts/CartContext';
import { useNavigate } from 'react-router-dom';

const FlotingCart: React.FC = () => {
  const { cartItems, getCartItemCount } = useCart();
  const navigate = useNavigate();
  const itemCount = getCartItemCount();
  
  const [isHeaderVisible, setIsHeaderVisible] = useState(true);
  const [lastScrollY, setLastScrollY] = useState(0);
  
  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      
      // If scrolling down and scrolled more than 100px
      if (currentScrollY > lastScrollY && currentScrollY > 100) {
        setIsHeaderVisible(false);
      } 
      // If scrolling up or at the top
      if (currentScrollY < lastScrollY || currentScrollY < 100) {
        setIsHeaderVisible(true);
      }
      
      setLastScrollY(currentScrollY);
    };
    
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, [lastScrollY]);

  // Get up to 3 recently added items' images
  const getRecentItemImages = () => {
    if (!cartItems || cartItems.length === 0) return [];
    
    // Get the last 3 unique items (in case same item is added multiple times)
    const uniqueItems = Array.from(new Map(
      [...cartItems].reverse().map(item => [item.productId + (item.variantSku || ''), item])
    ).values()).slice(0, 3);

    return uniqueItems.map(item => ({
      src: item.variantImage || item.imageUrl || 'https://cdn-icons-png.flaticon.com/512/3081/3081648.png',
      alt: item.name || 'Product image'
    }));
  };

  if (itemCount === 0) {
    return null; // Don't render anything if cart is empty
  }

  const handleClick = () => {
    navigate('/cart');
  };

  return (
    <div className={`floating-cart-wrapper ${!isHeaderVisible ? 'floating-cart-bottom' : ''}`}>
      <div className="floting-cart-container" onClick={handleClick}>
        <div className="floting-cart-images">
          {getRecentItemImages().map((img, index) => (
            <div key={index} className="floting-cart-image" style={{
              zIndex: 10 - index,
              marginLeft: index > 0 ? '-8px' : '0'
            }}>
              <img
                src={img.src}
                alt={img.alt}
                onError={(e) => {
                  (e.target as HTMLImageElement).src = 'https://cdn-icons-png.flaticon.com/512/3081/3081648.png';
                }}
              />
            </div>
          ))}
        </div>
        <div className="floting-cart-text">
          <div className="floting-cart-title">View cart</div>
          <div className="floting-cart-items">{itemCount} {itemCount === 1 ? 'Item' : 'Items'}</div>
        </div>
        <div className="floting-cart-icon">
          <ChevronRight size={18} color="#fff" />
        </div>
      </div>
    </div>
  );
};

export default FlotingCart;
